// React/Next imports
// Third-party libraries
import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';
// Types
import type { AvailableTaskType } from '@/components/composite/FirstStats/Content';

type AvailableTasksListProps = {
    tasks: AvailableTaskType[];
};

const AvailableTasksList = ({ tasks }: AvailableTasksListProps) => {
    const { t } = useTranslation('commons');

    return (
        <div className="flex flex-col space-y-4">
            {tasks.map((task) => (
                <a
                    key={task.slug}
                    href={task.url}
                    className={clsx(
                        'flex flex-row items-center space-x-3 rounded-md border border-icoGray-300 p-5 text-left text-icoGray-500 dark:border-icoDarkMode-beton dark:text-icoDarkMode-wolf'
                    )}>
                    <Icon
                        icon={task.icon}
                        className={clsx(
                            'flex h-8 w-8 items-center justify-center rounded-md text-lg',
                            {
                                'bg-icoPurple-100 text-icoPurple dark:bg-icoPurple/20':
                                    task.slug === 'content-inspiration',
                                'bg-icoYellow-100 text-icoYellow dark:bg-icoYellow/20':
                                    task.slug === 'create-group',
                                'bg-icoGreen-100 text-icoGreen dark:bg-icoGreen/20':
                                    task.slug === 'schedule-report',
                                'bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20':
                                    task.slug === 'schedule-post'
                            }
                        )}
                    />
                    <div className="flex flex-1 flex-col space-y-1 pr-2 xs:pr-5">
                        <p className="text-sm text-icoBlack dark:text-white">
                            {t(`modal_first_stats_status.tasks.${task.slug}.title`)}
                        </p>
                        <p className="font-GMedium text-xs">
                            {t(`modal_first_stats_status.tasks.${task.slug}.description`)}
                        </p>
                    </div>
                    <span className="hidden flex-row items-center space-x-1 xs:flex">
                        <Icon icon="soon" className="text-sm" />
                        <span className="text-9">
                            {task.duration} {t('modal_first_stats_status.minutes')}
                        </span>
                    </span>
                    <Icon icon="chevron-right" className="text-lg" />
                </a>
            ))}
        </div>
    );
};

export default AvailableTasksList;
